module.exports = __webpack_public_path__ + "static/media/luum.5137d48f.png";